// extracted by mini-css-extract-plugin
export default {"container":"ComboboxCoso_container__adulw","school":"ComboboxCoso_school__fLFTr","logo":"ComboboxCoso_logo__xVU9E","name":"ComboboxCoso_name__kvN7o"};